import { Chain } from "lib/types";

export const SUBGRAPHS = {
  mainnet: "succinctlabs/telepathy-mainnet",
  goerli: "succinctlabs/telepathy-goerli",
  gnosis: "succinctlabs/telepathy-gnosis",
  arbitrum: "succinctlabs/telepathy-arbitrum",
  binance: "succinctlabs/telepathy-binance",
  polygon: "succinctlabs/telepathy-polygon",
  optimism: "succinctlabs/telepathy-optimism",
  avalanche: "succinctlabs/telepathy-avalanche",
} as {
  [S in Chain]: string;
};

export function getSubgraphName(chain: Chain) {
  if (chain === undefined) {
    throw new Error(`Chain undefined`);
  }
  const name = SUBGRAPHS[chain];
  if (name === undefined) {
    throw new Error(`Subgraph for ${chain} not configured`);
  }
  return name;
}
